import { type IntervalType } from "../constants";

interface IntervalSelectorProps {
  selectedInterval: IntervalType;
  onChange: (interval: IntervalType) => void;
  className?: string;
}

export const IntervalSelector = ({ selectedInterval, onChange, className = "" }: IntervalSelectorProps) => {
  const intervals: { value: IntervalType; label: string }[] = [
    { value: "days", label: "Days" },
    { value: "weeks", label: "Weeks" },
    { value: "months", label: "Months" },
  ];

  return (
    <div className={`flex rounded-md border border-gray-200 ${className}`}>
      {intervals.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={`
            flex-1 px-3 py-1 text-sm font-medium transition-colors
            first:rounded-l-md last:rounded-r-md
            ${selectedInterval === value ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"}
          `}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
